import { render, staticRenderFns } from "./required.vue?vue&type=template&id=c529c8dc"
import script from "./required.vue?vue&type=script&lang=js"
export * from "./required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports